import { useDecisioningData } from "../DecisioningDataContext";
import { FactorColumn } from "./FactorColumn";
import { FactorsBoardProvider } from "./FactorsBoardContext";

/** Pros and Cons side by side once the panel is about 640px wide, stacked below that. */
export const FactorsTab = () => {
	const { proCons } = useDecisioningData();

	return (
		<FactorsBoardProvider>
			<div
				className="grid grid-cols-[repeat(auto-fit,minmax(296px,1fr))] gap-4"
				data-testid="factors-tab"
			>
				<FactorColumn kind="pro" proCons={proCons} />
				<FactorColumn kind="con" proCons={proCons} />
			</div>
		</FactorsBoardProvider>
	);
};
